import React, { PropTypes } from 'react';
const Linje = ({value}) => {

    const size = require('styleTools/SizeClasses.scss');
    const sizeClass = (value && value.storlek && size[value.storlek]) || size.m;
    const tjocklek = (typeof value === 'string' && value) || (value && value.tjocklek) || "1px";
    const marginal = (value && value.marginal) || "80px";
    const farg = (value && value.farg) || "#ebebeb";
    const style = require('./Linje.scss');
      return (
        <div className={sizeClass}>
          <hr style={{marginTop: parseInt(marginal)/2 + "px", marginBottom: parseInt(marginal)/2 + "px",border:"none", height:tjocklek, backgroundColor: farg}}/>
        </div>
      );
};

export default Linje;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Linje/Linje.js
 **/